import React, { useEffect, useState, useRef } from 'react';

import { InputBase } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import cx from 'classnames';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

import CloseIcon from '../../../../assets/icons/CloseIcon';
import SearchIcon from '../../../../assets/icons/SearchIcon';
import useStyles from './styles';

interface SearchProps {
  currentRefinement?: string;
  wrapperClass?: string;
  refine: Function;
  handleClear?: Function;
  withClear?: boolean;
}

const Search: React.FC<SearchProps> = ({
  currentRefinement = '',
  refine,
  wrapperClass = '',
  handleClear = undefined,
  withClear = false,
}) => {
  const { t } = useTranslation();
  const classes = useStyles(withClear)();
  const location = useLocation();

  const [value, setValue] = useState('');

  const inputRef = useRef<HTMLInputElement>(null);

  const onChange = (e) => {
    setValue(e.target.value);
  };

  const onKeyPress = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      search();
      inputRef?.current?.blur();
    }
  };

  const resetSearch = () => {
    setValue('');
    handleClear && handleClear();
  };

  const search = () => {
    refine(value);
  };

  useEffect(() => {
    setValue(currentRefinement);
  }, [currentRefinement, location]);

  return (
    <div className={cx(classes.wrapper, wrapperClass)}>
      {withClear && value && (
        <IconButton
          data-testid="clearSearchBox"
          className={classes.closeIconWrapper}
          aria-label="clear"
          onClick={resetSearch}
          size="large"
        >
          <CloseIcon />
        </IconButton>
      )}
      <InputBase
        className={cx(classes.input, value && 'active')}
        value={value}
        onChange={onChange}
        placeholder={t('input.placeholder.search')}
        inputProps={{ 'aria-label': 'enter key words', 'data-testid': 'searchBox' }}
        onKeyPress={onKeyPress}
        inputRef={inputRef}
      />
      <IconButton
        data-testid="submitSearch"
        type="submit"
        aria-label="search"
        onClick={search}
        className={classes.searchIcon}
        size="large"
      >
        <SearchIcon />
      </IconButton>
    </div>
  );
};

export default Search;
